/* global google */
define('views/pages/wishlist/offers/page',['require','underscore','jquery','views/base/page','text!templates/pages/wishlist/offers/page.ejs'],function(require) {
    'use strict';

    var _ = require('underscore'),
        $ = require('jquery'),
        PageView = require('views/base/page'),
        template = require('text!templates/pages/wishlist/offers/page.ejs');


    var WishlistOfferPageView = PageView.extend({
        autoRender: true,
        template: template,
        region: 'offers',
        regions: {
            'wishlist-result-filter-days': '.page-nav',
            'wishlist-results': '',
            'wishlist-result-filter': '.filter-summary-container',
            'wishlist-result-filter-list': '.page-nav>.pull-right'
        },

        listen: {
        },

        events: {
            'input .search-query': 'searchChanged',
            'propertychange .search-query': 'searchChanged',
        },

        windowResize: true,

        constructor: function() {
            this.searchChanged = _.debounce(this.searchChanged, 200);
            PageView.apply(this, arguments);
        },

        searchChanged: function(el) {
            this.model.set('search', $(el.currentTarget).val());
        }

    });

    return WishlistOfferPageView;
});

